/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careful_Exact_Dog_InvalidInputs */

const en_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The email address you've entered is invalid. Please either try a new email address, or check for typos.`)
};

const id_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat email yang Anda masukkan tidak valid. Silakan coba alamat email baru, atau periksa kesalahan ketik.`)
};

const ms_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat emel yang anda masukkan tidak sah. Sila cuba alamat emel yang baharu, atau semak untuk kesilapan ejaan.`)
};

const ca_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'adreça de correu electrònic que has introduït no és vàlida. Si us plau, torna a provar amb una nova adreça o comprova si hi ha errors tipogràfics.`)
};

const cs_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zadaná emailová adresa je neplatná. Zadejte prosím novou emailovou adresu nebo zkontrolujte překlepy.`)
};

const da_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mailadressen, du har indtastet, er ugyldig. Prøv enten en ny e-mailadresse, eller tjek for tastefejl.`)
};

const de_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die eingegebene E-Mail-Adresse ist ungültig. Bitte versuchen Sie eine neue E-Mail-Adresse oder überprüfen Sie auf Tippfehler.`)
};

const et_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sisestatud e-posti aadress on vigane. Proovige kas uut e-posti aadressi või kontrollige vigu.`)
};

const es_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La dirección de correo electrónico que has introducido no es válida. Por favor, intenta una nueva dirección de correo electrónico o revisa si hay errores tipográficos.`)
};

const fr_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’adresse e-mail que vous avez saisie n’est pas valide. Vérifiez votre saisie ou saisissez une nouvelle adresse e-mail.`)
};

const hr_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail adresa koju ste unijeli nije važeća. Molimo pokušajte novu e-mail adresu ili provjerite ima li tipfelera.`)
};

const it_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'indirizzo email inserito non è valido. Prova un nuovo indirizzo email o verifica i possibili errori di digitazione.`)
};

const lv_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ievadītā e-pasta adrese ir kļūdaina. Lūdzu, mēģiniet ievadīt citu e-pasta adresi vai pārbaudiet, vai nav kļūdu.`)
};

const lt_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Įvestas el. pašto adresas yra neteisingas. Bandykite kitą adresą arba patikrinkite, ar nėra klaidų.`)
};

const hu_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az ön által megadott email cím érvénytelen. Kérjük, próbáljon meg egy új email címet, vagy ellenőrizze a gépelési hibákat.`)
};

const nl_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het opgegeven e-mailadres is ongeldig. Probeer een nieuw e-mailadres of controleer op typefouten.`)
};

const nb_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-postadressen du har skrevet inn er ugyldig. Sjekk stavemåten eller skriv inn en annen e-postadresse.`)
};

const pl_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podany adres e-mail jest nieprawidłowy. Użyj innego adresu e-mail lub sprawdź, czy nie ma literówek.`)
};

const pt_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O endereço de e-mail inserido é inválido. Por favor, tente um novo endereço de e-mail ou verifique se há erros de digitação.`)
};

const ro_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresa de e-mail introdusă este invalidă. Vă rugăm să încercați o nouă adresă de e-mail sau să verificați eventualele greșeli de tipografie.`)
};

const sk_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zadaná e-mailová adresa je neplatná. Skúste zadať novú adresu alebo skontrolujte preklepy.`)
};

const sl_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-poštni naslov, ki ste ga vnesli, je neveljaven. Poskusite znova z novim naslovom ali preverite napake pri tipkanju.`)
};

const fi_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syöttämäsi sähköpostiosoite on virheellinen. Yritä uutta sähköpostiosoitetta tai tarkista kirjoitusvirheet.`)
};

const sv_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-postadressen du har angett är ogiltig. Vänligen försök antingen med en ny e-postadress eller kontrollera om det finns skrivfel.`)
};

const vi_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa chỉ email bạn đã nhập không hợp lệ. Vui lòng thử một địa chỉ email mới, hoặc kiểm tra lỗi chính tả.`)
};

const tr_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Girdiğiniz e-posta adresi geçersiz. Lütfen yeni bir e-posta adresi deneyin veya yazım hatalarını kontrol edin.`)
};

const el_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η διεύθυνση email που εισάγατε δεν είναι έγκυρη. Παρακαλούμε δοκιμάστε μια νέα διεύθυνση email, ή ελέγξτε για τυπογραφικά λάθη.`)
};

const bg_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имейл адресът, който сте въвели, е невалиден. Моля, опитайте нов имейл адрес или проверете за грешки.`)
};

const ru_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введенный вами адрес электронной почты недействителен. Попробуйте новый адрес или проверьте на опечатки.`)
};

const sr_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Унета емаил адреса није важећа. Покушајте са новом адресом или проверите грешке у уносу.`)
};

const uk_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адреса електронної пошти, яку ви ввели, недійсна. Будь ласка, спробуйте нову адресу електронної пошти або перевірте, чи немає помилок.`)
};

const ka_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`თქვენს მიერ შეყვანილი მეილის მისამართი არასწორია. გთხოვთ, სცადოთ ახალი მეილის მისამართი ან შეამოწმოთ შეცდომები.`)
};

const hi_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपके द्वारा दर्ज किया गया ईमेल पता अमान्य है। कृपया एक नया ईमेल पता आजमाएं, या टाइपो की जांच करें।`)
};

const th_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ที่อยู่อีเมลที่คุณป้อนไม่ถูกต้อง โปรดลองใช้ที่อยู่อีเมลใหม่ หรือ ตรวจสอบการพิมพ์ผิด`)
};

const ko_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`입력한 이메일 주소가 올바르지 않습니다. 새 이메일 주소를 시도하거나, 오타가 있는지 확인하세요.`)
};

const zh_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您输入的电子邮件地址无效。请尝试输入一个新的电子邮件地址，或检查拼写是否正确。`)
};

const zh_tw_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您輸入的電子郵件地址無效。請嘗試輸入新的電子郵件地址，或檢查是否有輸入錯誤。`)
};

const ja_careful_exact_dog_invalid = /** @type {(inputs: Careful_Exact_Dog_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入力されたメールアドレスは無効です。新しいメールアドレスを試すか、タイプミスがないか確認してください。`)
};

/**
* | output |
* | --- |
* | "The email address you've entered is invalid. Please either try a new email address, or check for typos." |
*
* @param {Careful_Exact_Dog_InvalidInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const careful_exact_dog_invalid = /** @type {((inputs?: Careful_Exact_Dog_InvalidInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careful_Exact_Dog_InvalidInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_careful_exact_dog_invalid(inputs)
	if (locale === "ms") return ms_careful_exact_dog_invalid(inputs)
	if (locale === "ca") return ca_careful_exact_dog_invalid(inputs)
	if (locale === "cs") return cs_careful_exact_dog_invalid(inputs)
	if (locale === "da") return da_careful_exact_dog_invalid(inputs)
	if (locale === "de") return de_careful_exact_dog_invalid(inputs)
	if (locale === "et") return et_careful_exact_dog_invalid(inputs)
	if (locale === "es") return es_careful_exact_dog_invalid(inputs)
	if (locale === "fr") return fr_careful_exact_dog_invalid(inputs)
	if (locale === "hr") return hr_careful_exact_dog_invalid(inputs)
	if (locale === "it") return it_careful_exact_dog_invalid(inputs)
	if (locale === "lv") return lv_careful_exact_dog_invalid(inputs)
	if (locale === "lt") return lt_careful_exact_dog_invalid(inputs)
	if (locale === "hu") return hu_careful_exact_dog_invalid(inputs)
	if (locale === "nl") return nl_careful_exact_dog_invalid(inputs)
	if (locale === "nb") return nb_careful_exact_dog_invalid(inputs)
	if (locale === "pl") return pl_careful_exact_dog_invalid(inputs)
	if (locale === "pt") return pt_careful_exact_dog_invalid(inputs)
	if (locale === "ro") return ro_careful_exact_dog_invalid(inputs)
	if (locale === "sk") return sk_careful_exact_dog_invalid(inputs)
	if (locale === "sl") return sl_careful_exact_dog_invalid(inputs)
	if (locale === "fi") return fi_careful_exact_dog_invalid(inputs)
	if (locale === "sv") return sv_careful_exact_dog_invalid(inputs)
	if (locale === "vi") return vi_careful_exact_dog_invalid(inputs)
	if (locale === "tr") return tr_careful_exact_dog_invalid(inputs)
	if (locale === "el") return el_careful_exact_dog_invalid(inputs)
	if (locale === "bg") return bg_careful_exact_dog_invalid(inputs)
	if (locale === "ru") return ru_careful_exact_dog_invalid(inputs)
	if (locale === "sr") return sr_careful_exact_dog_invalid(inputs)
	if (locale === "uk") return uk_careful_exact_dog_invalid(inputs)
	if (locale === "ka") return ka_careful_exact_dog_invalid(inputs)
	if (locale === "hi") return hi_careful_exact_dog_invalid(inputs)
	if (locale === "th") return th_careful_exact_dog_invalid(inputs)
	if (locale === "ko") return ko_careful_exact_dog_invalid(inputs)
	if (locale === "zh") return zh_careful_exact_dog_invalid(inputs)
	if (locale === "zh-tw") return zh_tw_careful_exact_dog_invalid(inputs)
	if (locale === "ja") return ja_careful_exact_dog_invalid(inputs)
	return en_careful_exact_dog_invalid(inputs)
});